import { Backdrop, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { googleFunctionService } from "../../services/axios";

const GlobalLoader = () => {
  const [isLoading, setIsLoading] = useState(0);
  useEffect(() => {
    const requestInterceptor = googleFunctionService.interceptors.request.use(
      (config) => {
        setIsLoading((oldValue) => oldValue + 1);
        return config;
      },
      (error) => {
        setIsLoading((oldValue) => oldValue - 1);
        return Promise.reject(error);
      }
    );

    const responseInterceptor = googleFunctionService.interceptors.response.use(
      (response) => {
        setIsLoading((oldValue) => oldValue - 1);
        return response;
      },
      (error) => {
        setIsLoading((oldValue) => oldValue - 1);
        return Promise.reject(error);
      }
    );

    return () => {
      googleFunctionService.interceptors.request.eject(requestInterceptor);
      googleFunctionService.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return (
    <Backdrop style={{ zIndex: 10001 }} open={!!isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalLoader;
